import { IHolidayListVM } from '../../models/response/IHolidayResponse';
const initialHolidayState: IHolidayListVM = {
  Schedules: [],
};

export default initialHolidayState;
